import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Client } from 'src/users';
import DrawerFlow, { DrawerFlowStep } from 'src/UI/drawer-flow/DrawerFlow';
import SelectClientStep from 'src/UI/drawer-flow/SelectClientStep';
import AgendaSelectTemplateStep from './steps/AgendaSelectTemplateStep';
import AgendaProgressOneSvg from './assets/agenda-progress-one.svg?react';
import AgendaProgressTwoSvg from './assets/agenda-progress-two.svg?react';

type AgendaFlowProps = {
  opened: boolean;
  close: () => void;
};

type AgendaData = {
  client?: Client;
  selectedTemplateId?: string;
};

const initialData: AgendaData = {
  client: undefined,
  selectedTemplateId: undefined,
};

const steps: DrawerFlowStep<AgendaData>[] = [
  {
    title: 'Select client',
    showClientName: false,
    screens: [
      {
        component: SelectClientStep,
        renderProgress: () => <AgendaProgressOneSvg />,
      },
    ],
  },
  {
    title: 'Select template',
    clientNamePrefix: 'for',
    screens: [
      {
        component: AgendaSelectTemplateStep,
        renderProgress: () => <AgendaProgressTwoSvg />,
      },
    ],
  },
];

export default function AgendaFlow({ opened, close }: AgendaFlowProps) {
  const navigate = useNavigate();
  const [data, setData] = useState<AgendaData>(initialData);

  const onSuccess = useCallback(
    (data: AgendaData) => {
      const clientId = data.client?.id;
      navigate(`/client/${clientId}/document/meeting-agendas`);
    },
    [navigate],
  );

  return (
    <DrawerFlow
      opened={opened}
      close={close}
      title="Meeting agenda"
      steps={steps}
      initialData={initialData}
      data={data}
      setData={setData}
      onSuccess={onSuccess}
    />
  );
}
